import httpClient from './index';

const END_POINT = 'project';

const projects = data => httpClient.get(`${END_POINT}`, { params: data });

export { projects };
